module.exports = __webpack_public_path__ + "img/brand-cases16.f75f9680.png";